import Axios from 'axios';
import {urlAPIDirectus} from "../config/globals";

function findAll(){
    return Axios
        .get(urlAPIDirectus+"batiment?fields=*.*.*.*,fichiers.item:fichier.*,plans.item:plan.*,maquettes.item:fichier.*,matiere_chaine.groupe_matiere_chaine_id.*.*.*.*.*")
        .then(response => response.data.data);
}

export default {
    findAll
}